import { TipoImovelAmostra } from '../types/laudo-wizard.types';

export interface AmostraPadrao {
  identificacao: string;
  tipoImovel: TipoImovelAmostra;

  areaPrivativa: number;
  areaTerreno: number;
  valorTotal: number;

  idadeAparente: number;
  estadoConservacao: string;

  // Quantidade de cômodos/vagas
  quantidadeQuartos?: number;
  quantidadeBanheiros?: number;
  quantidadeVagas?: number;

  cubBase?: number;
  ajusteAcabamento?: number;

  padrao?: string;
  topografia?: string;
  endereco?: string;

  fonte?: string;
  urlOriginal?: string;
  imagemUrl?: string; // Foto do imóvel do scraping
  externalId?: string; // ID externo do imóvel no banco (para proxy de imagem)
  selecionadaHomogeneizacao?: boolean; // Se está selecionada para o cálculo de homogeneização
  rankingHomogeneizacao?: number; // Posição no ranking (1 = melhor, 2 = segunda melhor, etc.)
}

export const AMOSTRAS_PADRONIZADAS: AmostraPadrao[] = [
  {
    identificacao: 'Avaliando',
    tipoImovel: 'Casa',
    areaPrivativa: 0,
    areaTerreno: 0,
    valorTotal: 0,
    idadeAparente: 0,
    estadoConservacao: 'Regular',
    cubBase: 2500.00,
    ajusteAcabamento: 1.0,
    padrao: 'Médio',
    topografia: 'Terreno Plano',
    endereco: '',
    fonte: 'manual',
  },
];
